import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import ContentContainer from "../../../components/container/ContentContainer";
import ContentContainerNew from "../../../components/container/ContentContainerNew";
import ContactExpert from "../../../components/controls/ContactExpert";
import Header from "../../../components/sections/Header";
import HeadData from "../../../data/HeadData";
import { useStaticQuery, graphql } from "gatsby";
import TitleSubDiv from "../../../components/controls/TitleSubDiv";
import ButtonAction from "../../../components/controls/ButtonAction";
import Layout from "../../../components/layout/Layout";
import YoutubePlayerLite from "../../../components/controls/YoutubePlayerLite";

const ThermallyModifiedWood = () => {
  const heroImage = useStaticQuery(graphql`
    {
      backGround: file(relativePath: { eq: "Lunawood-Thermowood-bg.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            placeholder: BLURRED
            formats: [AUTO, WEBP]
            quality: 100
          )
        }
      }      
    }
  `);

  const path = ["Thermally Modified Wood Products in Southern California"];
  return (
    <Layout>
      <div className="w-full max-w-full relative overflow-hidden">
        <HeadData 
          title="Thermally Modified Wood Products - So Cal"
          description="Lunawood Thermowood® is a beautiful wood material that is made by using only heat and steam. The thermal modification makes the wood dimensionally stable and weatherproof completely without chemicals." 
        />
        <Header />
        <TitleSubDiv
          parentText="Products"
          title="Thermally Modified Wood Products in Southern California"
          className="mb-8"
          path={path}
        />
        <ContentContainer
          className="relative w-full max-w-content md:mx-5 flex items-center justify-center"
          opacityClassName="bg-opacity-60"
          image={heroImage.backGround}
        >
          <div className="flex flex-col items-center justify-center my-20 gap-y-4 w-full max-w-3xl">
            <h1 className="text-3xl md:text-4xl text-white text-center font-bold">Lunawood ThermoWood<sup>&reg;</sup></h1>
            <p className="text-xl text-white text-center">Designed and manufactured in Finland, now available in the U.S.</p>
            <p className="text-base mt-5 text-center text-white">
              Lunawood offers beautiful, sustainable wood solutions produced in Finland and the USA using only heat and steam. The thermal modification process makes their products dimensionally stable and weather-resistant, entirely without the use of chemicals. Lunawood products are ideal for facades, interiors, and landscaping in all climatic conditions.
            </p>
            <ButtonAction to="/contact" className="mt-10 bg-actionBlue text-white px-16">
              Request Free Quote
            </ButtonAction>            
          </div>
        </ContentContainer>

        <div className="w-11/12 flex flex-col md:flex-row items-center justify-center mx-auto py-1 border-b space-x-4">
          <p className="text-sm text-center"><span className="font-bold uppercase">Photo</span>: Demanova Village</p>
          <p className="text-sm text-center"><span className="font-bold uppercase">Architect</span>: Ing. arch. Jakub Loučka, XYLO Atelier</p>
          <p className="text-sm text-center"><span className="font-bold uppercase">Photo By</span>: XYLO Atelier</p>
        </div>

        <ContentContainerNew
          containerClassName="w-full mt-10 md:mt-24"
          className="flex flex-col px-0 md:px-4 w-full max-w-7xl"
        >
          <div className="flex flex-col sm:flex-row">
            <div className="w-full sm:w-7/12 p-5 sm:pl-0 sm:pr-8">
              <h2 className="text-3xl font-bold pb-12 text-center tracking-normal normal-case md:text-left">
                Lunawood ThermoWood<sup>&reg;</sup>
              </h2>
              <p className="mb-6 font-bold">
                Siding | Battens | Decking | Interior
              </p>
              <p className="mb-6">
                Lunawood ThermoWood<sup>&reg;</sup> is a beautiful wood material that is made by using only heat and steam. The thermal modification makes the wood dimensionally stable and weatherproof completely without chemicals. These unique features inspire architects and designers to create stunning projects around the world.
              </p>
              <p>
                Lunawood products can be used in facades, interiors and landscaping in all climatic conditions.
              </p>
            </div>
            <div className="w-11/12 sm:w-5/12 mx-auto">
              <YoutubePlayerLite youtubeID="rkzG93t27UM" />
            </div>
          </div>
        </ContentContainerNew>

        <ContentContainerNew className="w-full max-w-content mt-8 md:mt-16">
          <h2 className="text-center bg-gray1 uppercase py-8">Collection</h2>
          
          <div>
            <div className="flex flex-col items-center justify-center my-14">
              <p className="text-2xl md:text-3xl uppercase text-center">Luna Arctic Pre-Greyed</p>
              <hr className="border-blue4 border-t-2 mt-4 w-56" />
            </div>
            <div className="w-full bg-gray2 flex flex-col lg:flex-row items-center justify-center p-12 space-y-12 lg:space-y-0 lg:space-x-12">            
              <div className="flex flex-col items-center justify-center">
                <StaticImage
                  src="../../../images/thermally-modified-wood/collections/luna-arctic/Luna-Arctic-Triple-brushed.jpg"
                  alt="Luna Arctic Triple"
                  placeholder="blurred"
                  width={400}
                  height={470}
                  quality={100}
                  layout="constrained"
                />              
                <div className="w-full h-24 bg-actionBlue p-6">                
                  <p className="text-xl md:text-2xl text-white text-center font-bold">Luna Arctic Triple</p>
                  <p className="text-sm text-white text-center">6/4 x 6 Brushed</p>
                </div>              
                <p className="text-base mt-4 font-bold text-center">LW-646ARTRP</p>
              </div>
              <div className="flex flex-col items-center justify-center">
                <StaticImage
                  src="../../../images/thermally-modified-wood/collections/luna-arctic/Luna-Arctic-Layer-brushed.jpg"
                  alt="Luna Arctic Layer"
                  placeholder="blurred"
                  width={400}
                  height={470}
                  quality={100}
                  layout="constrained"
                />
                <div className="w-full h-24 bg-actionBlue p-6">                
                  <p className="text-xl md:text-2xl text-white text-center font-bold">Luna Arctic Layer</p>
                  <p className="text-sm text-white text-center">1 x 6 Brushed</p>
                </div>              
                <p className="text-base mt-4 font-bold text-center">LW-16ARSHIP</p>
              </div>
            </div>
          </div>

          <div>
            <div className="flex flex-col items-center justify-center my-14">
              <p className="text-2xl md:text-3xl uppercase text-center">Lunawood 3D-Look</p>
              <hr className="border-blue4 border-t-2 mt-4 w-56" />
            </div>
            <div className="w-full bg-gray2 flex flex-col lg:flex-row items-center justify-center p-12 space-y-12 lg:space-y-0 lg:space-x-12">            
              <div className="flex flex-col items-center justify-center">
                <StaticImage
                  src="../../../images/thermally-modified-wood/collections/lunawood-3d/Lunawood_Luna-Triple-Shadow.jpg"
                  alt="Luna Triple"
                  placeholder="blurred"
                  width={400}
                  height={470}
                  quality={100}
                  layout="constrained"
                />              
                <div className="w-full h-24 bg-actionBlue p-6">                
                  <p className="text-xl md:text-2xl text-white text-center font-bold">Luna Triple</p>
                  <p className="text-sm text-white text-center">6/4 x 6</p>
                </div>              
                <p className="text-base mt-4 font-bold text-center">LW-646TRP</p>
              </div>
              <div className="flex flex-col items-center justify-center">
                <StaticImage
                  src="../../../images/thermally-modified-wood/collections/lunawood-3d/Luna-Duo-3D-panel.jpg"
                  alt="Luna Duo"
                  placeholder="blurred"
                  width={400}
                  height={470}
                  quality={100}
                  layout="constrained"
                />
                <div className="w-full h-24 bg-actionBlue p-6">                
                  <p className="text-xl md:text-2xl text-white text-center font-bold">Luna Duo</p>
                  <p className="text-sm text-white text-center">6/4 x 6</p>
                </div>              
                <p className="text-base mt-4 font-bold text-center">LW-646DUO</p>
              </div>
            </div>
          </div>

          <div>
            <div className="flex flex-col items-center justify-center my-14">
              <p className="text-2xl md:text-3xl uppercase text-center">Decking</p>
              <hr className="border-blue4 border-t-2 mt-4 w-56" />
            </div>
            <div className="w-full bg-gray2 flex flex-col lg:flex-row items-center justify-center p-12 space-y-12 lg:space-y-0 lg:space-x-12">            
              <div className="flex flex-col items-center justify-center">
                <StaticImage
                  src="../../../images/thermally-modified-wood/collections/decking/Luna-SHP-2-Profix-2.jpg"
                  alt="Luna SHP Profix2"
                  placeholder="blurred"
                  width={400}
                  height={470}
                  quality={100}
                  layout="constrained"
                />              
                <div className="w-full h-24 bg-actionBlue p-6">                
                  <p className="text-xl md:text-2xl text-white text-center font-bold">Luna SHP Profix2</p>
                  <p className="text-sm text-white text-center">5/4 x 6 WW</p>
                </div>              
                <p className="text-base mt-4 font-bold text-center">LW-546SHPWW</p>
              </div>
            </div>
          </div>

          <div>
            <div className="flex flex-col items-center justify-center my-14">
              <p className="text-2xl md:text-3xl uppercase text-center">Cladding and Paneling</p>
              <hr className="border-blue4 border-t-2 mt-4 w-56" />
            </div>
            <div className="w-full bg-gray2 flex flex-col lg:flex-row items-center justify-center p-12 space-y-12 lg:space-y-0 lg:space-x-12">            
              <div className="flex flex-col items-center justify-center">
                <StaticImage
                  src="../../../images/thermally-modified-wood/collections/cladding-paneling/Luna-TGV-1.jpg"
                  alt="Luna TGV"
                  placeholder="blurred"
                  width={400}
                  height={470}
                  quality={100}
                  layout="constrained"
                />              
                <div className="w-full h-24 bg-actionBlue p-6">                
                  <p className="text-xl md:text-2xl text-white text-center font-bold">Luna TGV</p>
                  <p className="text-sm text-white text-center">1 x 6</p>
                </div>              
                <p className="text-base mt-4 font-bold text-center">LW-16TGV</p>
              </div>

              <div className="flex flex-col items-center justify-center">
                <StaticImage
                  src="../../../images/thermally-modified-wood/collections/cladding-paneling/Luna-Layer-brushed.jpg"
                  alt="Luna Layer"
                  placeholder="blurred"
                  width={400}
                  height={470}
                  quality={100}
                  layout="constrained"
                />              
                <div className="w-full h-24 bg-actionBlue p-6">                
                  <p className="text-xl md:text-2xl text-white text-center font-bold">Luna Layer</p>
                  <p className="text-sm text-white text-center">1 x 6 Brushed</p>
                </div>              
                <p className="text-base mt-4 font-bold text-center">LW-16BRSHIP</p>
              </div>

              <div className="flex flex-col items-center justify-center">
                <StaticImage
                  src="../../../images/thermally-modified-wood/collections/cladding-paneling/Luna-Trim-Hidden-Nailing-HN-Brushed.jpg"
                  alt="Luna Trim HN (Hidden Nailer)"
                  placeholder="blurred"
                  width={400}
                  height={470}
                  quality={100}
                  layout="constrained"
                />              
                <div className="w-full h-24 bg-actionBlue p-6">                
                  <p className="text-xl md:text-2xl text-white text-center font-bold">Luna Trim HN</p>
                  <p className="text-sm text-white text-center"> (Hidden Nailer) 1 x 6</p>
                </div>              
                <p className="text-base mt-4 font-bold text-center">LW-16HN</p>
              </div>
            </div>
          </div>

          <div>
            <div className="flex flex-col items-center justify-center my-14">
              <p className="text-2xl md:text-3xl uppercase text-center">Accessories</p>
              <hr className="border-blue4 border-t-2 mt-4 w-56" />
            </div>
            <div className="w-full bg-gray2 flex flex-col lg:flex-row items-center justify-center p-12 space-y-12 lg:space-y-0 lg:space-x-12">            
              <div className="flex flex-col items-center justify-center">
                <StaticImage
                  src="../../../images/thermally-modified-wood/collections/accessories/lunawood-profix2-installation-box.png"
                  alt="Luna Profix 2 Plus Installation Box"
                  placeholder="blurred"
                  width={400}
                  height={470}
                  quality={100}
                  layout="constrained"
                />              
                <div className="w-full h-24 bg-actionBlue p-6">                
                  <p className="text-xl md:text-2xl text-white text-center font-bold">Luna Profix 2 Plus Installation Box</p>
                </div>              
                <p className="text-base mt-4 font-bold text-center">LW-P2PINSTL</p>
              </div>
              <div className="flex flex-col items-center justify-center">
                <StaticImage
                  src="../../../images/thermally-modified-wood/collections/accessories/lunawood-decking-screw-1.png"
                  alt="Luna Façade"
                  placeholder="blurred"
                  width={400}
                  height={470}
                  quality={100}
                  layout="constrained"
                />
                <div className="w-full h-24 bg-actionBlue p-6">                
                  <p className="text-xl md:text-2xl text-white text-center font-bold">Luna Façade</p>
                  <p className="text-sm text-white text-center">#5 x 2” ss 500 ct</p>
                </div>              
                <p className="text-base mt-4 font-bold text-center">LW-TX10</p>
              </div>
            </div>
          </div>

          <ContentContainerNew className="w-full max-w-content mt-8 md:mt-16">
            <h2 className="text-center bg-gray1 uppercase py-8">Projects</h2>
            
            <div className="w-full grid grid-col-1 lg:grid-cols-2 py-12 gap-12">            
              <div className="wfull flex flex-col items-center justify-center">
                <StaticImage
                  src="../../../images/thermally-modified-wood/projects/Lunawood-ThermoWood-Battens.jpg"
                  alt="Lunawood ThermoWood Battens Project"
                  placeholder="blurred"
                  width={800}
                  height={450}
                  quality={100}
                  layout="constrained"
                />              
                <div className="w-full bg-actionBlue p-6">
                  <p className="text-xl md:text-2xl text-white text-center font-bold">Lunawood ThermoWood<sup>&reg;</sup> Battens Project</p>

                  <p className="text-white text-center text-sm pt-2"><span className="font-bold uppercase">Photo</span>: Solar Shading in Bloemfontein</p>
                  <p className="text-white text-center text-sm pt-1"><span className="font-bold uppercase">Photo By</span>: Lunawood</p>
                </div>
              </div>
              <div className="wfull flex flex-col items-center justify-center">
                <StaticImage
                  src="../../../images/thermally-modified-wood/projects/Luna-Arctic-Layer-Cladding-Project.jpg"
                  alt="Luna Arctic Layer Cladding Project"
                  placeholder="blurred"
                  width={800}
                  height={450}
                  quality={100}
                  layout="constrained"
                />              
                <div className="w-full bg-actionBlue p-6">                
                  <p className="text-xl md:text-2xl text-white text-center font-bold">Luna Arctic Layer Cladding Project</p>

                  <p className="text-white text-center text-sm pt-2"><span className="font-bold uppercase">Photo</span>: (Grey House) Luna Arctic Layer</p>
                  <p className="text-white text-center text-sm pt-1"><span className="font-bold uppercase">Photo By</span>: Lunawood</p>
                </div>
              </div>
              <div className="wfull flex flex-col items-center justify-center">
                <StaticImage
                  src="../../../images/thermally-modified-wood/projects/Lunawood-Thermowood-Facade-Project.jpg"
                  alt="Lunawood Thermowood Facade Project"
                  placeholder="blurred"
                  width={800}
                  height={450}
                  quality={100}
                  layout="constrained"
                />              
                <div className="w-full bg-actionBlue p-6">
                  <p className="text-xl md:text-2xl text-white text-center font-bold">Lunawood Thermowood<sup>&reg;</sup> Facade Project</p>

                  <p className="text-white text-center text-sm pt-2"><span className="font-bold uppercase">Photo</span>: Urban Barnyard House</p>
                  <p className="text-white text-center text-sm pt-1"><span className="font-bold uppercase">Architect</span>: Inbetween Architecture</p>
                  <p className="text-white text-center text-sm pt-1"><span className="font-bold uppercase">Photo By</span>: Nic Granleese</p>
                </div>
              </div>
              <div className="wfull flex flex-col items-center justify-center">
                <StaticImage
                  src="../../../images/thermally-modified-wood/projects/Lunawood-Thermowood-Interior-Project-kitchen.jpg"
                  alt="Lunawood Thermowood Interior Project"
                  placeholder="blurred"
                  width={800}
                  height={450}
                  quality={100}
                  layout="constrained"
                />              
                <div className="w-full bg-actionBlue p-6">
                  <p className="text-xl md:text-2xl text-white text-center font-bold">Lunawood Thermowood<sup>&reg;</sup> Interior Project</p>

                  <p className="text-white text-center text-sm pt-2"><span className="font-bold uppercase">Photo</span>: (Kitchen) Louisville Residence</p>
                  <p className="text-white text-center text-sm pt-1"><span className="font-bold uppercase">Architect</span>: Bari Architecture</p>
                  <p className="text-white text-center text-sm pt-1"><span className="font-bold uppercase">Photo By</span>: Bonnie Sen</p>
                </div>
              </div>
            </div>
          </ContentContainerNew>

          <div className="w-full flex flex-col items-center justify-center">
            <p className="text-center text-lg md:text-xl uppercase mt-8 mb-6">For More Information:</p>            
          </div>
          <div className="w-auto mx-auto flex flex-col items-center justify-center">
            <a href="https://www.youtube.com/playlist?list=PLe1q5LEPWt-AKMMcZrCMRnPwRZIX4iWWm" target="_blank" rel="noopener noreferrer">
              <button className="bg-actionBlue text-white px-8 py-3 text-lg rounded-full text-center">
                Installation of Lunawood Thermowood Products
              </button>
            </a>

            <a href="https://lunawood.com/us/download-centre/" target="_blank" rel="noopener noreferrer">
              <button className="bg-actionBlue text-white px-8 py-3 text-lg rounded-full text-center mt-8">
               Technical Guides and Installation Videos
              </button>
            </a>

            <a href="https://lunawood.com/us/" target="_blank" rel="noopener noreferrer">
              <button className="bg-actionBlue text-white px-8 py-3 text-lg rounded-full text-center mt-8">
                Lunawood - North America Collection
              </button>
            </a>
          </div>
        </ContentContainerNew>

        <ContentContainer className="w-full max-w-content mt-16 mb-6">
          <div className="bg-gray2 text-center flex flex-col gap-y-10 py-10 sm:py-24 px-5 xl:px-102 text-lg md:text-xl">
            <i>
              “Harvested from renewable forests in the USA and modified with over 20 years of expertise, Lunawood’s North America Collection combines local craftsmanship with timeless Nordic design. The new Collection features premium products made from thermally modified Yellow Poplar and White Ash, enhanced completely without chemicals. Designed to meet the highest standards of technical performance and aesthetic appeal,<br/> Lunawood brings a touch of nature to all spaces, even in the most demanding environments.”
            </i>
            <p>- LUNAWOOD NORTH AMERICA</p>
          </div>
        </ContentContainer>

        <ContactExpert />
      </div>
    </Layout>
  );
};

export default ThermallyModifiedWood;
